import React, { useEffect, useState } from 'react';
import { useKeycloak } from "@react-keycloak/web";
import ProjectsTemplate from "../../Templates/Projects";
import ProjectService from '../../../services/Projects/ProjectService';
import Swal from "sweetalert2";

export default function ProjectsPage() {
  const { keycloak, initialized } = useKeycloak();
  const KEYCLOACK_TOKEN = keycloak.token;

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadProjects();
  }, [initialized, keycloak.token]);
  
  const loadProjects = async () => {
    try {
      if (initialized && keycloak.token) {
        setLoading(true)
        const allProjects = await ProjectService.getProjectsFromUser(KEYCLOACK_TOKEN);
        setLoading(false);
        setProjects(allProjects);
      }
    } catch (error) {
      Swal.fire({
        position: "top-end",
        title: "Erro ao buscar projetos",
        showConfirmButton: false,
        timer: 1800,
        background: '#27272A',
        color: '#fff',
      });
      setProjects([]);
    }
  }

  const handleDeleteProject = async (projectId) => {
    try {
      await ProjectService.deleteProjectById(projectId, KEYCLOACK_TOKEN);
  
      Swal.fire({
        position: "top-end",
        title: "Projeto excluído com sucesso",
        showConfirmButton: false,
        timer: 1800,
        background: '#27272A',
        color: '#fff',
      });
  
      loadProjects();
    } catch (error) {
      Swal.fire({
        icon: "error",
        position: "top-end",
        title: "Erro ao excluir projeto",
        showConfirmButton: false,
        timer: 1800,
        background: '#27272A',
        color: '#fff',
      });
    }
  }

  const handleFavoriteProject = async (projectId, isFavorite) => {
    try {
      await ProjectService.favoriteProjectById(projectId, KEYCLOACK_TOKEN);
  
      Swal.fire({
        position: "top-end",
        title: isFavorite ? "Projeto removido dos favoritos com sucesso" : "Projeto favoritado com sucesso",
        showConfirmButton: false,
        timer: 1800,
        background: '#27272A',
        color: '#fff',
      });

      loadProjects();
    } catch (error) {
      Swal.fire({
        icon: "error",
        position: "top-end",
        title: "Erro ao atualizar projeto",
        showConfirmButton: false,
        timer: 1800,
        background: '#27272A',
        color: '#fff',
      });
    }
  }

  const clients = projects.map(project => ({ name: project.client }));

  return (
      <ProjectsTemplate
          projects={projects}
          clients={clients}
          loadingProjects={loading}
          deleteFunction={handleDeleteProject}
          favoriteFunction={handleFavoriteProject}
      />
  )
}